import React from "react";
import apotekaLogo from "../../assets/logo_apoteka.svg";
import styles from "./Logo.module.css";
import { withRouter } from "react-router-dom";

const logo = (props) => {
  const returnToMainPageHandler = () => {
    if (props.location.pathname === "/") {
      window.scrollTo(0, 0);
      if (props.location.hash) {
        props.history.replace("/");
      }
    } else {
      const url = "/";
      props.history.push(url);
    }
  };

  return (
    <div className={styles.Logo} onClick={returnToMainPageHandler}>
      <img src={apotekaLogo} alt="apotekaLogo" />
    </div>
  );
};

export default withRouter(logo);
